import { FilterOptionsState } from '@mui/material';
import { DEFAULT_AUTOCOMPLETE_RESULT_LIMIT } from 'Config';
import { Option } from 'Components/HookFormInputs/AutoCompleteInput';

export const filterOptionsWithInputValue = (
  options: Option[],
  state: FilterOptionsState<Option>,
  resultLimit?: number,
): Option[] => {
  if (!state.inputValue.trim()) {
    return options;
  } else {
    const filtered = options.filter((option: Option) => {
      return `${option.value}`
        .toLowerCase()
        .includes(state.inputValue.toLowerCase());
    });
    return filtered?.slice(0, resultLimit || DEFAULT_AUTOCOMPLETE_RESULT_LIMIT);
  }
};
